"use client"
import moment from "moment";
import Link from "next/link";
import useHttp from "@/hooks/useHttp";
import { Icon } from "@iconify/react";
import { setCookie } from "cookies-next";
import { FaWhatsapp } from "react-icons/fa";
import Header from "@/components/header/header";
import { formatToBRL } from "@/helpers/formatter";
import React, { useState, useEffect } from "react";
import { useConfig } from "@/contexts/config-context";
import ModalCheckout from "@/components/modals/modal-checkout";
import { IoLogoWhatsapp, IoIosArrowDropdown } from "react-icons/io";
import { useParams, useRouter, useSearchParams } from "next/navigation";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { grey, green, lightBlue } from "@mui/material/colors";
import { Box, Card, Chip, Stack, Button, Collapse, Skeleton, Container, IconButton, Typography, CardContent, LinearProgress } from "@mui/material";

import TinyChip from "../chips/tiny-chip";
import NoticeComponent from "../NoticeComponent";
import RaffleNumbersSelect from "../inputs/raffle-numbers";
import ReadOnlyContent from "../html-render/ReadOnlyContent";
import CardRaffleThirty from "../raffles/card-raffle-thirty";
import InputNumbersThirty from "../inputs/input-numbers-thirty";
import ModalMyTicketsThirty from "../modals/modal-my-tickets-thirty";

export default function RaffleHomeThirty({
    jsonData
}) {
    const [misteryBoxes, setMisteryBoxes] = useState([
        {
            quantityBox: 1,
            quantityNumbers: 10
        },
        {
            quantityBox: 2,
            quantityNumbers: 20
        },
        {
            quantityBox: 3,
            quantityNumbers: 30
        },
        {
            quantityBox: 5,
            quantityNumbers: 50
        },
        {
            quantityBox: 10,
            quantityNumbers: 100
        },
        {
            quantityBox: 20,
            quantityNumbers: 200
        },
        {
            quantityBox: 30,
            quantityNumbers: 300
        },
        {
            quantityBox: 40,
            quantityNumbers: 400
        },
        {
            quantityBox: 50,
            quantityNumbers: 500
        },
    ]);
    const { get, post } = useHttp();
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [raffle, setRaffle] = useState({});
    const [options, setOptions] = useState([]);
    const [showModalGateway, setShowModalGateway] = React.useState(false);
    const [value, setValue] = React.useState(0);
    const [phone, setPhone] = React.useState("");
    const [showMyTickets, setShowMyTickets] = useState(false);
    const searchParams = useSearchParams();
    const router = useRouter();
    const [showMoreRoulettes, setShowMoreRoulettes] = useState(false);
    const [showMoreMisteryBoxes, setShowMoreMisteryBoxes] = useState(false);
    const [upsellPromotions, setUpsellPromotions] = useState([]);
    const [promotionId, setPromotionId] = useState(null);
    const config = useConfig();
    const [raffleNumbers, setRaffleNumbers] = useState([]);
    const [raffleInfo, setRaffleInfo] = useState({
        total_free_numbers: 0,
        total_paid_numbers: 0,
        total_reserved_numbers: 0
    });
    const [selectedNumbers, setSelectedNumbers] = useState([]);

    const getRaffles = async () => {
        let response = jsonData;

        setRaffle(response);
        let tempNumbers = [];
        if (response?.card_1_quantity)
            tempNumbers.push({ quantity: response.card_1_quantity, popular: response.card_popular == 1 });
        if (response?.card_2_quantity)
            tempNumbers.push({ quantity: response.card_2_quantity, popular: response.card_popular == 2 });
        if (response?.card_3_quantity)
            tempNumbers.push({ quantity: response.card_3_quantity, popular: response.card_popular == 3 });
        if (response?.card_4_quantity)
            tempNumbers.push({ quantity: response.card_4_quantity, popular: response.card_popular == 4 });
        if (response?.card_5_quantity)
            tempNumbers.push({ quantity: response.card_5_quantity, popular: response.card_popular == 5 });
        if (response?.card_6_quantity)
            tempNumbers.push({ quantity: response.card_6_quantity, popular: response.card_popular == 6 });

        setOptions(tempNumbers);
    };

    useEffect(() => {
        getRaffles();
    }, []);

    useEffect(() => {
        if (!raffle?.mistery_box_quantity_value) {
            return;
        }

        let tempMisteryBoxes = misteryBoxes.map(item => {
            item.value = item.quantityBox * raffle.mistery_box_quantity_value;
            return item;
        })
        setMisteryBoxes(tempMisteryBoxes);

    }, [raffle]);


    const formatNumber = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL', minimumFractionDigits: 2,
        maximumFractionDigits: 3
    });

    const selectPromotion = (item) => {
        setPromotionId(item.id);
        setValue(item.numbers_quantity);
        setShowModalGateway(true);
    };

    useEffect(() => {
        if (!raffle) {
            return
        }

        setValue(raffle?.min_numbers ?? 0)
    }, [raffle]);


    useEffect(() => {
        if (jsonData) {
            setLoading(false);
        }
    }, [jsonData])

    useEffect(() => {
        if (searchParams.get('i')) {
            setCookie("indicated_by", searchParams.get('i'));
        }

    }, []);

    const openShareLink = (type) => {
        const whatsappMessage = `Adquira o título de capitalização ${raffle.title} e concorra a prêmios incríveis!  Acesse o link e saiba mais: ${window.location.href} `;

        if (type == "facebook") {
            window.open(`https://www.facebook.com/share_channel/?type=reshare&link=${window.location.href}&source_surface=external_reshare&display&hashtag#`, '_blank');
        }
        if (type == "telegram") {
            window.open(`https://t.me/share/url?url=${window.location.href}`, '_blank');
        }
        if (type == "twitter") {
            window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`, '_blank');
        }
        if (type == "whatsapp") {
            window.open(`https://api.whatsapp.com/send?text=${whatsappMessage}`, '_blank');
        }
    }

    const handleMisteryBoxClick = (item) => {
        setValue(parseInt((item.value / raffle.numbers_price) ?? 0, 10));
        setShowModalGateway(true);
    }

    const listRaffleNumbers = async () => {
        let response = await get(`/api/raffles/${raffle.slug}/numbers`);

        setRaffleNumbers(response.numbers);
        setRaffleInfo({
            total_free_numbers: response.total_free_numbers,
            total_paid_numbers: response.total_paid_numbers,
            total_reserved_numbers: response.total_reserved_numbers
        });
    }

    useEffect(() => {
        if (!raffle?.slug) {
            return;
        }
        if (raffle?.type == "user_defined") {
            listRaffleNumbers();
        }
    }, [raffle, showModalGateway]);

    return (
        <Stack sx={{ mb: 5 }}>
            <Box style={{
                position: "fixed",
                top: 500,
                right: 5,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 10,
                zIndex: 999,
            }}>
                {
                    jsonData?.whatsapp_group &&
                    <Link href={jsonData?.whatsapp_group} target="_blank">
                        <Button size="small" style={{ minWidth: jsonData?.support_exibition_type == "icon_text" ? 110 : 60, fontSize: "0.7rem", backgroundColor: "#1b9b5b", }} variant="contained" color="primary"> <FaWhatsapp style={{ fontSize: 20 }} />&nbsp;{jsonData?.support_exibition_type == "icon_text" && "Grupo"}</Button>
                    </Link>
                }
                {
                    jsonData?.whatsapp_number &&
                    <Link href={`https://wa.me/+55${String(jsonData?.whatsapp_number).replace(/[^0-9.]/g, '')}`} target="_blank">
                        <Button size="small" style={{ minWidth: jsonData?.support_exibition_type == "icon_text" ? 110 : 60, fontSize: "0.7rem", backgroundColor: "#1b9b5b" }} variant="contained" color="primary"><IoLogoWhatsapp style={{ fontSize: 20 }} />&nbsp;{jsonData?.support_exibition_type == "icon_text" && "Whatsapp"}</Button>
                    </Link>
                }
                {
                    jsonData?.telegram &&
                    <Link href={jsonData?.telegram} target="_blank">
                        <Button size="small" style={{ minWidth: jsonData?.support_exibition_type == "icon_text" ? 110 : 60, fontSize: "0.7rem" }} variant="contained" color="primary"><Icon style={{ fontSize: 20 }} icon="ic:baseline-telegram" />&nbsp;{jsonData?.support_exibition_type == "icon_text" && "Telegram"}</Button>
                    </Link>
                }
                {
                    jsonData?.email &&
                    <Link href={`mailto:${jsonData?.email}`} target="_blank">
                        <Button size="small" style={{ minWidth: jsonData?.support_exibition_type == "icon_text" ? 110 : 60, fontSize: "0.7rem" }} variant="contained" color="primary"><Icon style={{ fontSize: 20 }} icon="material-symbols:mail" />&nbsp;{jsonData?.support_exibition_type == "icon_text" && "E-mail"}</Button>
                    </Link>
                }
                {
                    jsonData?.discord &&
                    <Link href={jsonData?.discord} target="_blank">
                        <Button size="small" style={{ minWidth: jsonData?.support_exibition_type == "icon_text" ? 110 : 60, fontSize: "0.7rem" }} variant="contained" color="primary"><Icon style={{ fontSize: 20 }} icon="ic:baseline-discord" />&nbsp;{jsonData?.support_exibition_type == "icon_text" && "Discord"}</Button>
                    </Link>
                }
            </Box>
            <ModalCheckout
                promotionId={promotionId}
                value={value}
                open={showModalGateway}
                onClose={() => setShowModalGateway(false)}
                raffle={raffle}
                setPhone={setPhone}
                quantity={value}
                setQuantity={setValue}
                setUpsellPromotions={setUpsellPromotions}
                upsellPromotions={upsellPromotions}
                selectedNumbers={selectedNumbers}
            />

            <Header color={config.appearance?.client_primary_color} />
            <Container sx={{
                width: '100%',
                maxWidth: '600px !important',
                marginTop: 9,
                zIndex: 50,
                background: "#DFE3E8",
                borderRadius: 2,
                paddingLeft: "0px!important",
                paddingRight: "0px!important",


            }}>
                {
                    loading ?
                        <SkeletonLoader /> :
                        <CardRaffleThirty
                            image={raffle.image_path}
                            title={raffle.title}
                            slug={raffle.slug}
                            description={raffle.short_description}
                            chipTextPromotion={raffle.chip_text_promotion}
                            raffle={raffle}
                            onClick={() => { }}
                            isThirty={true}
                        />
                }
                <ModalMyTicketsThirty raffle={raffle} setShowMyTickets={setShowMyTickets} open={showMyTickets} onClose={() => { setShowMyTickets(false) }} />
                {
                    (raffle?.sell_progress !== null && !loading) &&
                    <Box sx={{ mt: 0 }}>
                        <LinearProgress
                            value={raffle.custom_progress_percentage ? raffle.custom_progress_percentage : raffle.sell_progress}
                            variant="determinate"
                            color={'primary'}
                            sx={{ width: 1, height: 25 }}
                        />
                        <div style={{ textAlign: "center" }}>
                            <span className='align-auto' style={{ color: "black", marginTop: '-23px', position: "absolute" }}>{
                                String(raffle.custom_progress_percentage ? raffle.custom_progress_percentage : raffle.sell_progress).replace(".", ",")}%
                            </span>
                        </div>
                    </Box>
                }

                <Box sx={{ py: 1, gap: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {
                        loading ? <Skeleton width={100} height={20} /> :
                            <Box sx={{ display: "flex", justifyContent: raffle.show_draw_date_to_users ? "center" : "center", alignItems: "center", width: "100%" }}>
                                {
                                    raffle.show_draw_date_to_users &&
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Typography variant="subtitle2" fontWeight={"600"} fontSize={12}>Sorteio</Typography>
                                        <TinyChip sx={{ color: "black", background: "white", fontSize: 14, fontWeight: "600", padding: 0 }} label={`${moment(raffle.draw_date).format("DD/MM/YYYY")} Ás ${moment(raffle.draw_date).format("HH:mm")}`} />
                                    </Box>
                                }
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", alignContent: "flex-end", gap: 1 }} style={{ marginLeft: 16 }}>
                                    {
                                        raffle.numbers_price != "0.00"
                                            ? <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <Typography sx={{ marginRight: 1 }} variant="subtitle2" fontWeight={"600"} fontSize={10}>Por apenas </Typography>
                                                <TinyChip style={{ padding: "13px 5px", fontSize: '1em', backgroundColor: "black", color: "white" }} label={formatToBRL(raffle.numbers_price)} />
                                            </Box>
                                            :
                                            <TinyChip variant="filled" color="primary" sx={{ fontSize: 14, fontWeight: "600" }} label={"🤑🤑 Campanha gratuíta 🤑🤑"} />
                                    }
                                </Box>
                            </Box>
                    }

                </Box>

                {
                    (raffle.allow_promotion && !!raffle?.promotions.length) && <>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginX: 1 }}>
                            <Typography variant={"h6"} >📣 Promoção</Typography>
                            <small>Compre mais barato!</small>
                        </Box>
                        <Box className="bg-white p-2 flex flex-wrap gap-2 rounded-lg" sx={{ p: 1, borderRadius: 2, gap: 1, marginBottom: 1, marginX: 1 }}>
                            {
                                raffle.promotions.map((item, index) => (
                                    <Chip
                                        key={index + "a"}
                                        className="cursor-pointer"
                                        color="primary"
                                        label={`${item.numbers_quantity} por ${formatToBRL(item.value)}`}
                                        onClick={() => selectPromotion(item)}
                                    />))
                            }
                        </Box>
                    </>
                }

                <Box sx={{ mx: 1.4 }}>

                    {
                        !!raffle.show_notice &&
                        <NoticeComponent raffle={raffle} />
                    }


                    {
                        raffle.status == "active" && raffle.type == "normal" &&
                        <Box style={{ marginBottom: -15 }}>
                            <InputNumbersThirty
                                raffle={raffle}
                                value={value}
                                onChange={(e) => setValue(e)}
                                options={options}
                                minValue={raffle.min_numbers}
                                maxValue={raffle.max_numbers}
                                allowManualInput={raffle?.allow_manual_numbers}
                                setShowModalGateway={setShowModalGateway}
                                generalWinners={jsonData?.general_winners}
                            />
                        </Box>
                    }


                    {
                        !!raffle.winners?.length && <>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
                                <Typography variant={"h6"} >🎉 Ganhadores</Typography>
                                <small>sortudos</small>
                            </Box>
                            {
                                raffle.winners.map((item, index) => {
                                    return (
                                        <Card key={index + "b"} sx={{ padding: 1, margin: 0 }}>
                                            <CardContent sx={{ display: "flex", gap: 2, padding: "0!important", margin: 0, alignContent: "center" }}>
                                                <img src={item?.image_profile_path ? item?.image_profile_path : "/avatar.jpg"} style={{ width: 95, height: 110, borderRadius: 6, objectFit: "cover" }} className="rounded" />
                                                <Box sx={{ display: "flex", flexDirection: "column" }} className="flex flex-col justify-center align-center items-start">
                                                    <Typography variant="body1"><b>{item.name}</b></Typography>
                                                    <Typography sx={{ fontSize: "0.8em" }} variant="body1" className="mt-1">Prêmio: <b>{item.award}</b></Typography>
                                                    <Typography sx={{ fontSize: "0.8em" }} variant="body1">Número da sorte: <b>{item.number}</b></Typography>
                                                    <Typography sx={{ fontSize: "0.8em" }} variant="body1">Data da compra: <b>{moment(item.created_at).format("DD/MM/YYYY HH:mm")}</b></Typography>
                                                </Box>
                                            </CardContent>
                                        </Card>);
                                })
                            }
                        </>
                    }

                    {
                        raffle.type == 'user_defined' && <>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                                <Typography variant={"h6"} >⚡ Títulos</Typography>
                                <Typography variant={"caption"} >Escolha sua sorte</Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between", mb: 2, mt: 1 }}>
                                <div style={{ display: "flex", alignItems: "center", mt: 2, cursor: 'pointer' }}>
                                    <div style={{ backgroundColor: 'white', padding: '3px 4px 3px 4px', borderRadius: '5px 0 0 5px', fontSize: 14, fontWeight: 700 }}>Livres</div>
                                    <div style={{ backgroundColor: grey[700], padding: '3px 4px 3px 4px', borderRadius: '0 5px 5px 0', fontSize: 14, fontWeight: 700, color: "white" }}>{raffleInfo?.total_free_numbers}</div>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", mt: 2, cursor: 'pointer' }}>
                                    <div style={{ backgroundColor: 'white', padding: '3px 4px 3px 4px', borderRadius: '5px 0 0 5px', fontSize: 14, fontWeight: 700 }}>Reservados</div>
                                    <div style={{ backgroundColor: lightBlue[700], padding: '3px 4px 3px 4px', borderRadius: '0 5px 5px 0', fontSize: 14, fontWeight: 700, color: "white" }}>{raffleInfo?.total_reserved_numbers}</div>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", mt: 2, cursor: 'pointer' }}>
                                    <div style={{ backgroundColor: 'white', padding: '3px 4px 3px 4px', borderRadius: '5px 0 0 5px', fontSize: 14, fontWeight: 700 }}>Pagos</div>
                                    <div style={{ backgroundColor: green[700], padding: '3px 4px 3px 4px', borderRadius: '0 5px 5px 0', fontSize: 14, fontWeight: 700, color: "white" }}>{raffleInfo?.total_paid_numbers}</div>
                                </div>
                            </Box>
                        </>
                    }

                    {
                        raffle.type == 'user_defined' &&
                        <RaffleNumbersSelect
                            numbersArray={raffleNumbers}
                            setQuantity={setValue}
                            raffle={raffle}
                            value={value}
                            setShowModalGateway={setShowModalGateway}
                            onChange={(selectedNumbers) => {
                                setValue(selectedNumbers.length)
                                setSelectedNumbers(selectedNumbers)
                            }}
                        />
                    }


                    {
                        (raffle.status == "active" && raffle?.wheel_combos && raffle?.wheel_combos.length > 0) &&
                        <Stack>
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                                    <Typography variant={"h6"} >🎯 Roletas instantâneas</Typography>
                                </Box>
                            </Box>
                            {
                                raffle.wheel_combos.map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            background: "linear-gradient(90deg, rgba(25,131,82,1) 0%, rgba(89,226,134,1) 100%);",
                                            borderRadius: 2,
                                            p: 1,
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 1,
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            if (item.type == 'value') {
                                                setValue(parseInt((item.value / raffle.numbers_price) ?? 0, 10));
                                            } else {
                                                setValue(item.numbers_quantity)
                                            }
                                            setShowModalGateway(true);
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="body1" color="white" fontSize={13} >A cada</Typography>
                                            <Typography color="white" fontWeight={700}>{item.type == "quantity" ? item.numbers_quantity : formatToBRL(item.value)} {item.type == "quantity" ? " Títulos" : " em compras"}</Typography>
                                            <Typography variant="body1" color="white" fontSize={13} fontWeight={400}>{item.wheel_quantity} chance(s) de contemplação nas Roletas instantâneas</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="body1" color="white" fontWeight={700} >Recebe {item.wheel_quantity} Roleta(s) 🎯</Typography>
                                        </Box>
                                    </Box>
                                ))
                            }


                        </Stack>
                    }

                    <Stack>
                        {
                            !!raffle?.award_numbers?.length && <>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                                    <Typography variant={"h6"} >🏆 Títulos premiados</Typography>
                                    <small>Instantâneos</small>
                                </Box>
                                {
                                    !!raffle.award_numbers.length && raffle.award_numbers.map((item, index) => {
                                        if (item.client_name) {
                                            return (
                                                <Box
                                                    key={index + "c"}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        borderRadius: .7,
                                                        background: "black",
                                                        color: "white",
                                                        p: .5,
                                                        height: 40,
                                                        my: .5
                                                    }}>
                                                    <Chip sx={{ background: "white", color: "black", borderRadius: .4, width: 85, fontSize: ".8em", height: 25 }} label={String(item.number).padStart(String(raffle.numbers_quantity).length - 1, "0")} />
                                                    <Typography fontWeight={"bold"} sx={{ fontSize: ".9em" }}>{item.award}</Typography>

                                                    <Typography fontWeight={"bold"} sx={{ fontSize: ".9em" }}>{item.client_name.split(" ")[0]} 🏆</Typography>
                                                </Box>
                                            );
                                        }
                                        return (<Box
                                            key={index + "c"}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                borderRadius: .7,
                                                background: "white",
                                                color: "black",
                                                p: .5,
                                                height: 40,
                                                my: .5
                                            }}>
                                            <Chip sx={{ bgcolor: "text.secondary", borderRadius: .4, width: 85, fontSize: ".8em", height: 25 }} label={String(item.number).padStart(String(raffle.numbers_quantity).length - 1, "0")} />
                                            <Typography sx={{ fontSize: ".9em" }} fontWeight={"bold"}>{item.award}</Typography>
                                            <Typography sx={{ fontSize: ".9em" }} fontWeight={"bold"}>Disponível</Typography>
                                        </Box>);
                                    })
                                }
                            </>
                        }
                    </Stack>

                    {
                        (raffle?.mistery_box_combo && raffle?.mistery_box_combo.length > 0) &&
                        <Stack>
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                                    <Typography variant={"h6"} >🎁 Combos Caixas misteriosas</Typography>
                                </Box>
                            </Box>
                            {
                                raffle?.mistery_box_combo.map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            background: "linear-gradient(90deg, rgba(25,131,82,1) 0%, rgba(89,226,134,1) 100%);",
                                            borderRadius: 2,
                                            p: 1,
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 1,
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            if (item.type == 'value') {
                                                setValue(parseInt((item.value / raffle.numbers_price) ?? 0, 10));
                                            } else {
                                                setValue(item.numbers_quantity)
                                            }
                                            setShowModalGateway(true);
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="body1" color="white" fontSize={13} >A cada</Typography>
                                            <Typography color="white" fontWeight={700}>{item.type == "quantity" ? item.numbers_quantity : formatToBRL(item.value)} {item.type == "quantity" ? " Títulos" : " em compras"}</Typography>
                                            <Typography variant="body1" color="white" fontSize={13} fontWeight={400}>{item.box_quantity} chance(s) de contemplação nas Caixinhas premiadas</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="body1" color="white" fontWeight={700} >Recebe {item.box_quantity} Caixa(s) 🎁</Typography>
                                        </Box>
                                    </Box>
                                ))
                            }


                        </Stack>
                    }

                    {
                        jsonData?.show_mistery_boxes_winners &&
                        <Stack>
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1, justifyContent: "center" }}>
                                    <Typography variant={"h6"} >🎁 Caixas misteriosas</Typography>
                                    <small>Ganhadores</small>
                                </Box>
                            </Box>
                            <Collapse in={showMoreMisteryBoxes} collapsedSize={220} >
                                <Stack sx={{ gap: 1 }}>
                                    {
                                        Array.from({ length: jsonData.total_boxes_to_show }).map((_, index) => (
                                            <Box key={index} sx={{ bgcolor: undefined != jsonData.mistery_box_winners[index] ? "#198754" : "white", p: 1, borderRadius: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                                {
                                                    undefined != jsonData.mistery_box_winners[index] ?
                                                        <>
                                                            <TinyChip label={jsonData?.mistery_box_winners[index]["award"]} />
                                                            <Typography variant="body2" sx={{ color: "white" }}><b>{jsonData.mistery_box_winners[index]["client_name"]} 🏆</b></Typography>
                                                        </>
                                                        :
                                                        <>
                                                            <TinyChip label="Não Premiado" style={{ backgroundColor: "#919eab", color: "white" }} />
                                                            {
                                                                jsonData?.mistery_boxes_awards[index]?.award &&
                                                                <Typography variant="body2" sx={{}}><b>{jsonData.mistery_boxes_awards[index]?.award}</b></Typography>
                                                            }
                                                            <Typography variant="body2" sx={{ color: "black" }}>Disponível</Typography>
                                                        </>
                                                }
                                            </Box>
                                        ))
                                    }
                                </Stack>
                            </Collapse>
                            <Box style={{ marginTop: 10 }} sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                <Button onClick={() => setShowMoreMisteryBoxes(!showMoreMisteryBoxes)} variant="text" color="primary" sx={{ color: green[700], fontSize: 17, fontWeight: 700 }}>
                                    {showMoreMisteryBoxes ? <>Ver menos &nbsp;<IoIosArrowDropdown style={{ fontSize: 25, transform: "rotate(180deg)" }} /></> : <>Ver mais &nbsp;<IoIosArrowDropdown style={{ fontSize: 25 }} /></>}
                                </Button>
                            </Box>
                        </Stack>
                    }


                    {
                        (raffle?.show_wheel_luck_awards) &&
                        <Stack>
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                                    <Typography variant={"h6"} >🎯 Roletas instantâneas</Typography>
                                    <small>Ganhadores</small>
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                                    <Button sx={{ color: green[700], fontWeight: 700 }} size="small" variant="outlined" color="success" >
                                        <span style={{ fontSize: 18 }}>{raffle.wheel_awards.items.length}</span> &nbsp;/&nbsp;<span style={{ fontSize: 13 }}>{raffle.wheel_awards.total_items}</span>
                                    </Button>
                                </Box>
                            </Box>
                            <Collapse in={showMoreRoulettes} collapsedSize={220} >
                                <Stack sx={{ gap: 1 }}>
                                    {
                                        Array.from({ length: raffle.wheel_awards.total_items }).map((_, index) => (
                                            <Box key={index} sx={{ bgcolor: undefined != raffle.wheel_awards.items[index] ? "#198754" : "white", p: 1, borderRadius: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                                {
                                                    undefined != raffle.wheel_awards.items[index] ?
                                                        <>
                                                            <TinyChip label={raffle.wheel_awards.items[index]["result_label"]} />
                                                            <Typography variant="body2" sx={{ color: "white" }}><b>{raffle.wheel_awards.items[index]["first_name"]} 🏆</b></Typography>
                                                        </>
                                                        :
                                                        <>
                                                            <TinyChip label="Não Premiado" style={{ backgroundColor: "#919eab", color: "white" }} />
                                                            <Typography variant="body2" sx={{ color: "black" }}>Disponível</Typography>
                                                        </>

                                                }
                                            </Box>
                                        ))
                                    }

                                </Stack>
                            </Collapse>
                            <Box style={{ marginTop: 10 }} sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                <Button onClick={() => setShowMoreRoulettes(!showMoreRoulettes)} variant="text" color="primary" sx={{ color: green[700], fontSize: 17, fontWeight: 700 }}>
                                    {showMoreRoulettes ? <>Ver menos &nbsp;<IoIosArrowDropdown style={{ fontSize: 25, transform: "rotate(180deg)" }} /></> : <>Ver mais &nbsp;<IoIosArrowDropdown style={{ fontSize: 25 }} /></>}
                                </Button>
                            </Box>
                        </Stack>
                    }

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
                        <Typography variant={"h6"} >📋 Descrição</Typography>
                    </Box>
                    <Accordion sx={{ mt: 1 }}>
                        <AccordionSummary
                            sx={{ background: "white", borderRadius: 1 }}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Button variant="text" fullWidth sx={{ color: grey[900] }}>
                                <Icon icon="mdi:arrow-down-circle-outline" style={{ fontSize: 20, marginRight: 2 }} />
                                <Typography fontWeight={700}>Descrição/Regulamento</Typography>
                            </Button>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ReadOnlyContent content={raffle.description} />
                        </AccordionDetails>
                    </Accordion>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        my: 5
                    }}>
                        <Typography>Compartilhe:</Typography>
                        <Box>
                            <IconButton onClick={() => openShareLink("facebook")}><Icon style={{ fontSize: 30 }} icon="logos:facebook" /></IconButton>
                            <IconButton onClick={() => openShareLink("telegram")}><Icon style={{ fontSize: 30 }} icon="logos:telegram" /></IconButton>
                            <IconButton onClick={() => openShareLink("twitter")}><Icon style={{ fontSize: 30 }} icon="logos:twitter" /></IconButton>
                            <IconButton onClick={() => openShareLink("whatsapp")}><Icon style={{ fontSize: 30 }} icon="logos:whatsapp-icon" /></IconButton>
                        </Box>
                    </Box>
                </Box>

            </Container>
        </Stack >
    );

}

const SkeletonLoader = () => {
    return (
        <div style={{
            minHeight: 300
        }}>
            <Skeleton className="rounded-lg" variant="rectangular" width={"100%"} height={300} />
        </div>
    );
}
